/* Move the existing Dawn controls; no cloned inputs or purchase handlers. */
(() => {
  if (window.__craftProductPurchaseRow) return;
  window.__craftProductPurchaseRow = true;
  const rows = new Map();
  const selector = '#MainContent product-info[id^="MainProduct-"]';
  let scheduled = false;

  function controlsFor(source) {
    if (source.closest('quick-add-modal, product-modal') || source.dataset.updateUrl === 'false') return null;
    if (source.querySelector('recipient-form, volume-pricing, price-per-item')) return null;
    const quantityBlocks = [...source.querySelectorAll('.product-form__quantity')];
    if (quantityBlocks.length !== 1) return null;
    const quantity = quantityBlocks[0];
    const input = quantity.querySelector('quantity-input .quantity__input');
    if (!input || quantity.querySelector('.quantity__rules')?.textContent.trim()) return null;
    const formId = input.getAttribute('form');
    const form = [...source.querySelectorAll('product-form form')].find(element => element.getAttribute('id') === formId);
    const productForm = form?.closest('product-form');
    if (!form || productForm?.dataset.hideErrors === 'true') return null;
    const buttons = form.querySelector('.product-form__buttons');
    const submit = buttons?.querySelector('.product-form__submit');
    if (!buttons || !submit || submit.form !== form || input.form !== form) return null;
    return { quantity, input, form, buttons, submit };
  }

  class PurchaseRow {
    constructor(source, controls) {
      this.source = source;
      Object.assign(this, controls);
      this.quantityAnchor = document.createComment('craft-purchase:quantity-origin');
      this.submitAnchor = document.createComment('craft-purchase:submit-origin');
      this.quantity.before(this.quantityAnchor);
      this.submit.before(this.submitAnchor);
      this.row = document.createElement('div');
      this.row.className = 'cp-purchase-row';
      this.submit.before(this.row);
      this.row.append(this.quantity, this.submit);
    }

    valid() {
      if (!this.source.isConnected || !this.source.contains(this.quantityAnchor) || !this.source.contains(this.submitAnchor)) return false;
      const current = controlsFor(this.source);
      return current?.quantity === this.quantity && current?.input === this.input && current?.form === this.form &&
        current?.buttons === this.buttons && current?.submit === this.submit && this.row.parentElement === this.buttons &&
        this.quantity.parentElement === this.row && this.submit.parentElement === this.row;
    }

    destroy() {
      // A buy-buttons rerender may detach the moved quantity. Its source anchor
      // preserves that same node and Dawn's cached quantity references.
      const sourceAlive = this.source.isConnected;
      const replacementQuantity = [...this.source.querySelectorAll('.product-form__quantity')]
        .some(element => element !== this.quantity);
      if (sourceAlive && this.source.contains(this.quantityAnchor) && !replacementQuantity) {
        this.quantityAnchor.before(this.quantity);
      }
      // Never resurrect an old submit button after native source replacement.
      if (sourceAlive && this.source.contains(this.submitAnchor) && this.source.contains(this.submit)) {
        this.submitAnchor.before(this.submit);
      }
      this.quantityAnchor.remove();
      this.submitAnchor.remove();
      if (this.row.isConnected && this.source.contains(this.row)) this.row.replaceWith(...this.row.childNodes);
      else this.row.remove();
      rows.delete(this.source);
    }
  }

  function scan() {
    scheduled = false;
    rows.forEach(row => { if (!row.valid()) row.destroy(); });
    document.querySelectorAll(selector).forEach(source => {
      if (rows.has(source)) return;
      const controls = controlsFor(source);
      if (!controls || controls.submit.closest('.cp-purchase-row')) return;
      rows.set(source, new PurchaseRow(source, controls));
    });
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  function initialize() {
    scan();
    const observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('product-info:loaded', scheduleScan);
    document.addEventListener('shopify:section:load', scheduleScan);
    document.addEventListener('shopify:section:unload', event => {
      rows.forEach(row => { if (event.target.contains(row.source)) row.destroy(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
